import { useEffect, useContext } from 'react';
import { StoreContext } from 'index';

const Logout = () => {
  const { authStore } = useContext(StoreContext);

  useEffect(() => {
    const performLogout = async () => {
      await authStore.doLogout();
    };

    performLogout();
  }, [authStore]);
};

export default Logout;
